<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12 md6 offset-md3)
        v-card.mt-2(raised v-if="order.entry_quotation")
          v-card-title.primary.white--text
            span 見積依頼書
          v-card-text.ma-1
            div.app-line
              span.app-line-title
              span.app-line-text
                v-icon.ma-1(large color="success") fa-file-pdf-o
                a(@click.stop="downloadRequest(order.entry_quotation.filepath)") {{order.entry_quotation.filename}}
              span.app-line-suffix

        v-card.mt-2(raised)
          v-card-title.primary.white--text
            span 見積書
          v-card-text.ma-1
            div.mb-4
              v-checkbox.mt-0(v-model="onlyLatest" label="最新の見積書のみ表示" hide-details)
            div(v-for="(q, index) in quotations" :key="index" v-if="onlyLatest ? !q.outdated : true")
              div.app-line
                span.app-line-title
                span.app-line-text
                  span(v-if="!q.outdated")
                    v-icon.pink--text.new-icon(large) fiber_new
                  v-icon.ma-1(large :color="q.outdated ? 'error' : 'success'") fa-file-pdf-o
                  a(@click.stop="downloadQuotation(q.filepath)") {{q.filename}}
                span.app-line-suffix

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      onlyLatest: true
    }
  },
  created () {},
  computed: {
    ...mapGetters('app/order', ['isNewOrder', 'order', 'quotations'])
  },
  methods: {
    ...mapActions('app/order', ['clearQuotations']),
    downloadRequest (filepath) {
      let self = this
      let encoded = encodeURIComponent(filepath)
      let v = window.open()
      self.$ajax.get(`order/presigned_request?q=${encoded}`).then(function (response) {
        let uri = response.data.uri
        v.location.href = uri
      })
    },
    downloadQuotation (filepath) {
      let self = this
      let encoded = encodeURIComponent(filepath)
      let v = window.open()
      self.$ajax.get(`order/presigned_quotation?q=${encoded}`).then(function (response) {
        let uri = response.data.uri
        v.location.href = uri
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.line-text {
  .fa {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  a:hover {
    cursor: pointer;
  }

  .new-icon {
    margin-top: -8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/Quotation.vue